import { useAppSelector } from "../../redux/hook";
import ApplicationCooLayout from "../../layout/application-coo-layout";
import { TextSubheader } from "../../components/text/text-subheader";
import { P2Alert, P2ButtonGroup, P2Button } from "react-bootstrap-common-script";
import { Separator } from "../../components/separator";
import { useNavigate } from "react-router-dom";
import { useCallback, useMemo, useRef, useEffect, useState } from "react";
import { Helpers } from "../../utils/helper";
import { useInitialWindowScrollTo } from "../../hooks/use-initial-window-scroll-to";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import { useGetPaymentInfoQuery } from "../../redux/services/getPaymentInfo";
import { PaymentMethodEnum } from "../../models/enum/payment-method.enum";
import { Payment_Method } from "../../utils/shared-radio";
import hdbLogo from "../../assets/images/hdb-logo.png";
import { stageCTrackingId } from "../../utils/wogaa-ids";
import { useWogaa } from "../../hooks/use-wogaa";
import { PolymerAxios } from "../../utils/axios";
import { API_EligibilityDebugLog } from "../../utils/api";
export interface PaymentSuccessDetailsProps {
  hash_no: number;
  transaction_date: string;
  transaction_time: string;
  pay_type: string;
}

const StageCSuccessful = () => {
  const startApplicationFormData = useAppSelector( (state) => state.app.ApplicationStartSlice.formData);
  const applicationId = useAppSelector( (state) => state.app.ApplicationIdSlice.applicationId);
  const queryParameters = new URLSearchParams(window.location.search)
  const applicationIdParam = queryParameters.get("application_id");
  const singpassToken = useAppSelector(state => state.auth.AuthenticationSlice.singpassToken);
  const loginUser = useAppSelector(state => state.auth.AuthenticationSlice.loginUser);

  let navigate = useNavigate();
  
  
  const applicationUuid = useMemo(()=>{
    let uuid = ""  
    if(applicationIdParam){
      uuid = applicationIdParam;
    }
    else if(applicationId){
      uuid = applicationId;
    }

    return uuid;
  },[applicationId, applicationIdParam])

  const { data, isError, isLoading, refetch } = useGetPaymentInfoQuery({application_uuid: applicationUuid, singpass_token: singpassToken ?? "" },{skip: !applicationUuid})
  const [numberOfRefetch, setNumberOfRefetch] = useState<number>(0);

  const paymentMethodDescription = useMemo(()=>{
    if(data?.pay_type === PaymentMethodEnum.card){
      return Payment_Method.find( e=> e.value === data?.pay_type)?.description
    }
    else if(data?.pay_type === PaymentMethodEnum.paynow){
      return Payment_Method.find( e=> e.value === data?.pay_type)?.description
    }
    else{
      return "-";
    }
  },[data])

  const navigateBack = useCallback(()=>{
    navigate('/');
  },[navigate])


  useInitialWindowScrollTo();

  // WOGAA tracking for Stage C - auto complete on successful payment
  useWogaa({
    trackingId: stageCTrackingId,
    autoStart: false,
    autoComplete: true,
    applicationId: applicationUuid ?? undefined,
    hdbRef: startApplicationFormData.selected_hdb_property?.hdb_ref,
  });

  const pdfRef = useRef(null);

  useEffect(() => {
    if(!applicationId){
      window.location.href = "/transfer/dashboard";
    }
  }, [applicationId])

  const handleDownload = useCallback(() => {
    const input = pdfRef.current;
    const image = new Image();
    const innerWidth = window.innerWidth;
    const isMobile = innerWidth <= 480;
    image.src = hdbLogo;
    image.width = !isMobile ? 200: 150;
    image.height = !isMobile ? 49 : 40;
    image.style.marginBottom = !isMobile ? "16px" : "12px";
    if (input) {
      html2canvas(input, {
        backgroundColor: null,
        onclone: (clonedDoc) => {
          const container = clonedDoc.getElementById(
            "polymer-stage-c-success-container"
          );
          if (container) {
            container.style.boxShadow = "unset";
            container.insertAdjacentElement("afterbegin", image);
          }
        },
      }).then((canvas) => {
        let pdf: jsPDF;
        if(isMobile){
          const resizedCanvas = document.createElement('canvas');
          const resizedContext = resizedCanvas.getContext('2d');

          // Set the new dimensions for the resized canvas
          const newWidth = 300; // Replace with the desired width
          const newHeight = (canvas.height * newWidth) / canvas.width;
          resizedCanvas.width = newWidth;
          resizedCanvas.height = newHeight;

          // Draw the original canvas onto the resized canvas with the new dimensions
          resizedContext!.drawImage(canvas, 0, 0, newWidth, newHeight);

          pdf = new jsPDF();
          const imgWidth = 80; // Replace with the desired width in the PDF
          const imgHeight = (newHeight * imgWidth) / newWidth;
          const x = (pdf.internal.pageSize.getWidth() - imgWidth) / 2;//set the receipt image to the middle of page
          // Add the resized image data URL to the PDF document
          const imgData = resizedCanvas.toDataURL('image/png');
          pdf.addImage(imgData, 'PNG', x, 10, imgWidth, imgHeight);
        }else{
          let imgWidth = 208;
          let imgHeight = (canvas.height * imgWidth) / canvas.width;
          const imgData = canvas.toDataURL("img/png");
          pdf = new jsPDF("p","mm", innerWidth >= 610 ? "a4" : [300, 350]);
          const x = (pdf.internal.pageSize.getWidth() - imgWidth) / 2;
          pdf.addImage(imgData, "PNG", x, 0, imgWidth, imgHeight);
        }
       
        pdf.save("payment-receipt.pdf");
      });
    }
  },[startApplicationFormData?.selected_hdb_property?.address]);


  const handlePrint = useCallback(()=>{
    window.print();
  },[]);

  useEffect(() => {
    if(!isLoading && isError && numberOfRefetch < 3){
      setTimeout(() => {
        setNumberOfRefetch((prev) => prev + 1);
        refetch();
      }, 10000)
    }
  }, [isLoading])

  useEffect(() => {
    DebugLogging();
  }, []);

  const DebugLogging = async () => {
    await PolymerAxios(loginUser?.uinfin ?? "", singpassToken).post(API_EligibilityDebugLog, {
      applicationUuid: loginUser?.uinfin,
      message: `FE STAGE C --- Successful Payment application ID:${applicationId}, Payment Method Description:${paymentMethodDescription}`
    });
  }

  if(data || numberOfRefetch >= 3){
    return (
      <ApplicationCooLayout>
        <div style={{ padding: "41px 41px 0px 40px" }} id="polymer-stage-c-success-container" ref={pdfRef}>
          <TextSubheader
            subheaderMain="Stage C: Make Payment"
            subheaderSub={startApplicationFormData.selected_hdb_property?.address}
          />
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 24,
              maxWidth: "1032px",
              margin: "24px auto 0",
            }}
          >
            <P2Alert
              style={{ boxShadow: "0px 2px 8px 0px #00000026" }}
              withCTA={false}
              variant="success"
              text={
                "Payment successful. You may check the status of your application in your dashboard."
              }
            />
            <p className="polymer-success-text" style={{ marginBottom: 0 }}>
              Thank you for your payment. Your application has been submitted to
              HDB. Please note that this is only an in-principle approval of your
              eligibility for the application. You will be notified once your
              application has progressed to the next stage.
            </p>{" "}
            <div className="polymer-button-group-wrapper">
              <P2ButtonGroup>
                <P2Button
                  variant={"outline-primary"}
                  onClick={handlePrint}
                >
                  Print
                </P2Button>{" "}
                <P2Button
                  variant={"outline-primary"}
                  onClick={handleDownload}
                >
                  Save as PDF
                </P2Button>
                <P2Button
                  variant={"primary-1"}
                  onClick={navigateBack}
                >
                  Back to dashboard
                </P2Button>
              </P2ButtonGroup>
            </div>
            <Separator />
          </div>
          <div className="polymer-success-container polymer-payment-table-container">
            <div
              className="polymer-payment-table-subcontainer"
              id="polymer-receipt-container"
              // ref={pdfRef}
            >
              <div className="polymer-payment-items-container polymer-payment-items-container-first">
                <p className="polymer-payment-items polymer-payment-items-text polymer-payment-items-text-highlight">
                  Transaction Hash No.
                </p>
                <p className="polymer-payment-items polymer-payment-items-text">
                  {data?.hash_no ?? "-"}
                </p>
              </div>
              <Separator />
              <div className="polymer-payment-items-container">
                <p className="polymer-payment-items polymer-payment-items-text polymer-payment-items-text-highlight">
                  Transaction Date
                </p>
                <p className="polymer-payment-items polymer-payment-items-text">
                  {data?.transaction_date ? Helpers.formatDate( data?.transaction_date) : "-"}
                </p>
              </div>
              <Separator />
              <div className="polymer-payment-items-container">
                <p className="polymer-payment-items polymer-payment-items-text polymer-payment-items-text-highlight">
                  Transaction Time
                </p>
                <p className="polymer-payment-items polymer-payment-items-text">
                  {data?.transaction_time ? Helpers.formatTime(data?.transaction_time) : "-"}
                </p>
              </div>
              <Separator />
              <div className="polymer-payment-items-container polymer-payment-items-container-last">
                <p className="polymer-payment-items polymer-payment-items-text polymer-payment-items-text-highlight">
                  Payment Mode
                </p>
                <p className="polymer-payment-items polymer-payment-items-text">
                  {paymentMethodDescription}
                </p>
              </div>
            </div>
          </div>
        </div>
      </ApplicationCooLayout>
    );
  } else {
    return <p>Loading...</p>
  }
};

export default StageCSuccessful;
